import BaseModel from './BaseModel';

class FilterModel extends BaseModel {
  constructor(data = {}) {
    super(data);
  }

  initialState = {
    limit: 10,
    offset: 0,
    title: '',
    barcode: '',
    relation_id: undefined,
    quantity: '',
    no_image: false,
    inactive: 1,
  }

  onChange = object => async (dispatch) => {
    dispatch({
      type: 'FILTER_CHANGE',
      object,
    });
  }

  reset = () => async (dispatch) => {
    dispatch({
      type: 'FILTER_RESET',
    });
  }

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case 'FILTER_CHANGE': {
        return {
          ...state,
          ...action.object,
        };
      }
      case 'FILTER_RESET': {
        return {
          ...state,
          ...this.initialState,
        };
      }
      default: {
        return {
          ...state,
        };
      }
    }
  }
}

export default FilterModel;


// const initialState = {
//   limit: 10,
//   offset: 0,
//   title: '',
//   barcode: '',
//   relation_id: undefined,
//   quantity: '',
//   no_image: false,
//   inactive: 1,
// };

// const object = {
//   title: 'bla',
//   barcode: '2',
//   limit: 10,
// };

// const changed = {
//   ...initialState,
//   ...object,
// };

// console.log(changed);



// WEBPACK FOOTER //
// ./src/models/FilterModel.js